"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XMLTextContent = exports.XMLNode = void 0;
function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
function makeEscape(escapeMap) {
    const phrases = Object.keys(escapeMap);
    const regex = new RegExp(`(${phrases.map(escapeRegExp).join('|')})`, 'g');
    function replacer(phrase) {
        return escapeMap[phrase];
    }
    return function escape(text) {
        return text.replace(regex, replacer);
    };
}
const escape = {
    regexp: escapeRegExp,
    xml: {
        text: makeEscape({
            '<': '&lt;',
            '&': '&amp',
        }),
        attribute: {
            text: makeEscape({
                '<': '&lt;',
                '&': '&amp',
                '"': '&quot;',
                "'": '&apos',
            }),
            name: makeEscape({
                '<': '&lt;',
                '>': '&gt;',
                '&': '&amp',
                '"': '&quot;',
                "'": '&apos',
            }),
        },
    },
};
class XMLNode {
    constructor(arg1, arg2, arg3) {
        const name = arg1;
        const attributes = Array.isArray(arg2) ? {} : arg2 || {};
        const children = Array.isArray(arg2) ? arg2 : arg3 || [];
        this.name = escape.xml.attribute.name(name);
        this.attributes = attributes;
        this.children = children;
    }
    toString(indent = '  ', newline = '\n', depth = '') {
        const { name, attributes, children } = this;
        const attributeString = Object.entries(attributes)
            .map(([k, v]) => `${escape.xml.attribute.name(k)}="${escape.xml.attribute.text(v)}"`)
            .join(' ');
        const attributeSpace = attributeString.length ? ' ' : '';
        const head = `${depth}<${name}${attributeSpace}${attributeString}`;
        let tail;
        if (children && children.length) {
            tail = `>${newline}${children
                .map((child) => child.toString(indent, newline, depth + indent))
                .join(newline)}${newline + depth}</${name}>`;
        }
        else {
            tail = ` />`;
        }
        return `${head}${tail}`;
    }
}
exports.XMLNode = XMLNode;
/**
 * The content of an XMLNode that is not a list of XMLNodes
 */
class XMLTextContent {
    constructor(unsafeContent) {
        const safeContent = escape.xml.text(unsafeContent ?? '');
        this.content = safeContent;
    }
    toString() {
        return this.content;
    }
}
exports.XMLTextContent = XMLTextContent;
//# sourceMappingURL=XML.js.map